import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BIO_AUTH_USER_CONST, biometricBaseUrl } from "constant";
import { handlingErrorResponse } from "utils/HandlingErrorResponse";
import { BioEndpointConst } from "./const";
import { IAttendancesLogListResponsesType, IBioUserRequestType, IDeviceInfoResponsesType, IEmployeeListResponsesType, IResponseType } from "./type";

export const BiometricApi = createApi({
    reducerPath: "BiometricApi",
    baseQuery: fetchBaseQuery({
        baseUrl: biometricBaseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem(BIO_AUTH_USER_CONST)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['BioAuth'],
    endpoints: (builder) => ({
        BioAuthLogin: builder.mutation<IResponseType<string>, IBioUserRequestType>({
            query: userReq => ({
                url: BioEndpointConst.bioAuthLoginUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'BioAuth', id: 'BioLogin' }],
        }),
        GeDeviceInfo: builder.query<IResponseType<IDeviceInfoResponsesType>, void>({
            query: () => ({
                url: BioEndpointConst.bioDeviceInfoUrl,
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'BioAuth', id: 'GeDeviceInfo' }],
        }),
        GeEmployeesList: builder.query<IResponseType<IEmployeeListResponsesType[]>, void>({
            query: () => ({
                url: BioEndpointConst.bioEmployeesListUrl,
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'BioAuth', id: 'GeEmployeesList' }],
        }),
        BioEmployeesSyncDb: builder.mutation<IResponseType<string>, void>({
            query: userReq => ({
                url: BioEndpointConst.bioEmployeesSyncDbUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'BioAuth', id: 'BioEmployeesSyncDb' }],
        }),
        GeAttendancesLogList: builder.query<IAttendancesLogListResponsesType, void>({
            query: () => ({
                url: BioEndpointConst.bioAttendancesLogUrl,
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'BioAuth', id: 'GeAttendancesLogList' }],
        }),
        BioAttendancesLogSyncDb: builder.mutation<IResponseType<string>, void>({
            query: userReq => ({
                url: BioEndpointConst.bioAttendancesLogSyncDbUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'BioAuth', id: 'BioAttendancesLogSyncDb' }],
        }),
        BioAttendancesLogCalculate: builder.mutation<IResponseType<string>, void>({
            query: userReq => ({
                url: BioEndpointConst.bioAttendancesLogCalculateUrl,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'BioAuth', id: 'BioAttendancesLogCalculate' }],
        }),
    }),
})